const contactInformation = {
  emailId: "support@pred.health",
  phoneNo: 9920596642,
};

export default contactInformation;
